<template>
  <modal
    :name="modalName || 'crud-edit'"
    height="auto"
    width="80%"
    :lazy="true"
    :scrollable="true"
    :clickToClose="false"
    v-if="!!schema"
  >
    <div v-if="alertMessage != null" class="alert alert-info mx-5 mt-5">
      {{ alertMessage }}
    </div>

    <CloseModal :close="closeModal" />
    <div class="modalbox">
      <div class="modalbox-content">
        <ncform
          :form-schema="schema"
          :form-name="form_id"
          v-model="schema.value"
          @submit="submit()"
        />
      </div>
    </div>
    <div class="modal-footer-bar">
      <slot name="edit-buttons" :model="schema.value"></slot>
      <CButton variant="outline" color="secondary" @click="closeModal">
        Cancelar
      </CButton>
      <CButton color="primary" @click="submit()">
        Salvar Alterações
      </CButton>
    </div>
  </modal>
</template>

<script>
import CloseModal from "../../components/CloseModal";
import { uuid } from "vue-uuid";

export default {
  name: "ModalEdit",
  props: [
    "formSchema",
    "formInputs",
    "editingItem",
    "onSubmit",
    "modalName",
    "alertMessage",
  ],
  components: {
    CloseModal,
  },
  data() {
    return {
      form_id: uuid.v4(),
      schema: {},
    };
  },
  watch: {
    editingItem: function () {
      this.reloadFormSchema();
    },
    formSchema: function () {
      this.reloadFormSchema();
    },
  },
  mounted() {
    document.addEventListener("keyup", this.handleEsc);
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.handleEsc);
  },
  methods: {
    reloadFormSchema() {
      this.schema = !!this.formSchema
        ? { ...this.formSchema, value: this.editingItem }
        : null;
      this.form_id = uuid.v4();

      // Esta linha remove os "false" de validação iniciais
      setTimeout(() => this.$ncformValidate(this.form_id), 1);
    },
    submit() {
      this.$ncformValidate(this.form_id).then((data) => {
        if (data.result) {
          this.onSubmit({
            ...this.editingItem,
            ...this.schema.value,
          });
        }
      });
    },
    handleEsc(e) {
      if (e.key === "Escape") {
        const openModals = document.querySelectorAll(".v--modal-overlay");
        if (openModals.length <= 1) {
          this.closeModal();
        }
      }
    },
    closeModal() {
      this.$modal.hide(this.modalName || "crud-edit");
    },
  },
};
</script>

<style scoped>
.modal-footer-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #fff;
}
</style>
